var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"character-card",class:{
        'for-dialog': _vm.forDialog,
    }},[_c('div',{staticClass:"user-pic"},[_c('img',{attrs:{"src":_vm.characterPic}})]),_c('div',{staticClass:"text-container"},[(_vm.showName)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.characterNameVerbose))]):_vm._e(),_c('div',{staticClass:"phrase",class:{ 'crop-if-character-name': _vm.showName }},[_vm._v(" "+_vm._s(_vm.characterPhrase)+" ")])]),_c('div',{staticClass:"button-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }